import "./customer-auth-shell.scss";

import { LocalFeatures } from "@core/model/local-features";
import { LocalProfile } from "@core/model/local-profile";
import { ApiToFormService } from "@core/services/api-to-form.service";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { FEATURES, PROFILE } from "@core/utility/settings";
import { GetResponseTenantModel } from "@factory/model/query-model-tenant";
import { useQyGetPerson } from "@factory/query/person.query";
import { useQyGetTenant } from "@factory/query/tenant.query";
import StorageService from "@shared/services/storage.service";
import { useState } from "react";
import { Outlet } from "react-router-dom";

import { appConfig } from "../../../app.config";
import { appFeature } from "../../../app.feature";
import { useAuthCustomerNavigation } from "./auth-customer-navigation";

 
export interface CustomerAuthShellProps {}

export function CustomerAuthShell() {
  const { getAuthUser } = useUserIdentityContext();
  const [tenantCode, setTenantCode] = useState<string>("")
  const logo = `${
    appConfig.assetPath
  }/icon-192x192.png?${new Date().toISOString()}`;
  const { headerElement } = useAuthCustomerNavigation(logo, appFeature.company);
  const { userCode } = getAuthUser();

  // PERSON API
  const handlePersonSuccess = (response: any) => {
    setTenantCode(response.data[0].tenant)
    const mappedData = ApiToFormService.MapProfile(response.data[0]);
    StorageService.save<LocalProfile>(PROFILE, mappedData);
  };
  useQyGetPerson(
    "",
    1,
    0,
    undefined,
    { code: userCode },
    !!userCode,
    handlePersonSuccess
  );

  // TENANT FEATURES
  const handleTenantSuccess = (response: GetResponseTenantModel) => {
    const responseData = response.data ?? [];
    if (responseData.length === 0) {
      return;
    }

    const mappedData = ApiToFormService.MapClientFeatures(responseData[0])
    StorageService.save<LocalFeatures>(FEATURES, mappedData)
  }
  useQyGetTenant(
    "",
    1,
    0,
    undefined,
    { code: tenantCode},
    undefined,
    undefined,
    undefined, !!tenantCode, handleTenantSuccess
  )

  return (
    <div id="CustomerAuthShell" className="customer-auth-shell">
      {headerElement}

      <section className="flex mt-4">
        <section className="flex-1 bg-gray-50 rounded-lg mr-4 ml-4 md:ml-0 overflow-y-auto">
          <Outlet />
        </section>
      </section>
    </div>
  );
}

export default CustomerAuthShell;
